import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Input,
  Label,
  FormGroup,
  FormFeedback,
} from "reactstrap";
import profile from "@assets/images/profile-img.png";
import logo from "@assets/images/logo.svg";
import { WELCOME_TXT } from "@constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "@helpers/validation-schema";
import { loginUser } from "../services/login-services";
import { toast, ToastContainer } from "react-toastify";
import { getItem } from "@helpers/helpers";
import { STORAGE_KEY } from "@constants/constants";
import { clearStorage } from "@helpers/helpers";
import { resetError } from "../controller/login-slice";
import { resetLogout } from "../controller/logout-slice";
import { LOGIN_PASSWORD_MAXLENGTH, LOGIN_USER_MAXLENGTH } from "../../../constants/constants";
export const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const errorMessage = useSelector((state) => state.login.errorMessage);
  const loginResponse = useSelector((state) => state.login.responseMessage);
  const successMessage = useSelector((state) => state.logout.successMessage);
  const user = getItem(STORAGE_KEY.USER);
  const [show, setShow] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  useEffect(() => {
    if (successMessage !== null) {
      toast.success(successMessage);
      dispatch(resetLogout());
      dispatch(resetError());
      clearStorage();
    }
  }, [successMessage]);
  
  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [dispatch, loginResponse]);

  const onSubmit = (data) => {
    dispatch(loginUser(data));
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden text-start">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{WELCOME_TXT}</h5>
                        <p>Sign in to continue to VV media.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <FormGroup>
                        <Label for="exampleUserName">
                          Email or Phone Number
                        </Label>
                        <Controller
                          name="username"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div>
                              <Input
                                {...field}
                                placeholder="Enter your email or phone number"
                                invalid={!!errors.username}
                                maxLength={LOGIN_USER_MAXLENGTH}
                              />
                              {errors.username && (
                                <FormFeedback>
                                  {errors.username.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="examplePassword">Password</Label>
                        <Controller
                          name="password"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="input-group auth-pass-inputgroup">
                              <Input
                                {...field}
                                type={show ? "text" : "password"}
                                placeholder="Enter your password"
                                invalid={!!errors.password}
                                maxLength={LOGIN_PASSWORD_MAXLENGTH}
                              />
                              <button
                                onClick={() => setShow(!show)}
                                className="btn btn-light"
                                type="button"
                                id="confirm-password-addon"
                              >
                                <i
                                  className={
                                    show
                                      ? "mdi mdi-eye-outline"
                                      : "mdi mdi-eye-off"
                                  }
                                />
                              </button>
                              {errors.password && (
                                <FormFeedback>
                                  {errors.password.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                      {/* <FormGroup>
                        <Label for="examplePassword">Password</Label>
                        <Controller
                          name="password"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div>
                              <Input
                                {...field}
                                type="password"
                                placeholder="Enter your password"
                                invalid={!!errors.password}
                              />
                              
                              {errors.password && (
                                <FormFeedback>
                                  {errors.password.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup> */}
                      {errorMessage && (
                        <p style={{ color: "red" }}>{errorMessage}</p>
                      )}
                      <button type="submit" className="btn btn-primary w-100">
                        Login
                      </button>
                    </form>

                    <div className="mt-4 text-center">
                      <Link to="/forgot-password" className="text-muted">
                        <i className="mdi mdi-lock me-1" />
                        Forgot your password?
                      </Link>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Login;
